export enum TaskStatus {
    Open = 1,
    Read = 2,
    Approved = 3,
    Rejected = 4,
    Cancelled = 5,
    Completed = 6
}